<script setup lang="ts">
import SSHeader from '../components/SSHeader.vue'
import SSFooter from '../components/footer/SSFooter.vue'
import SSWidgets from '../components/widgets/SSWidgets.vue'
</script>

<template>
  <SSHeader overlay />
  <main class="ss-app__main" data-testid="ss-app-main-game-layout">
    <slot name="main-content" />
  </main>
  <SSWidgets />
  <SSFooter class="ss-app__footer-game" />
</template>

<style lang="scss" scoped>
.ss-app {
  &__footer-game {
    position: absolute;
    bottom: var(--nxgds-alias-spacing-3xs);
    width: calc(100% - 300px - 3 * var(--nxgds-alias-spacing-3xs));
    z-index: 1;
  }
}
</style>
